var CrmAutoresponders = $.extend(false, BaseModule ,{
    api_route : 'crm/autoresponders',	
	data : {
				module:'crm-autoresponders',
				offset:20,
				page:0,
				sort_term:'date_send',
				sort_way:'DESC',
				status:'',
                view:'list',
				type:''
			},
	
	actions:function(action,id,rel){
		var module_name = this.data.module;
		var module = this;
		
		switch(action){
			case "new":
                GlobalModule.new_entry(module_name);
				break;
			case "order":
				this.order();
				break;
			case "edit":
            case "duplicate":
                GlobalModule.load_entry(id,module_name,action);
				break;
            case "delete":
            case "delete-selected":
                GlobalModule.delete_entry(id,module_name);
                break;
		}
	},

    load_stats_list:function(page,additionals){
        var module_name = this.data.module,
            module = this,
            request_data = additionals;//$.extend(false, additionals || {}, module.data);
        request_data.module  = module_name.split('-')[0];
        request_data.action  = "load-"+module_name+"-list";
        request_data.page = page || 0;
        request_data.offset = 50;
        request_data.data_type = 'html';

        $('.'+module_name+'-stats-list:visible').html('<span class="spinner"><i class="fa fa-spinner fa-spin"></i></span>');

        $.ajax({
            data:request_data,
            dataType:'html',
            success:function(data){
                $('.'+module_name+'-stats-list:visible').html(data);
                initForm('.'+module_name+'-stats-list:visible');
                $('.'+module_name+'-stats-list:visible .pagination a').on('click', function () {
                    if($(this).parent().hasClass('active')) return false;
                    var page = $(this).data('page');
                    var module_name = $(this).closest('.pagination').data('target');
                    module.load_stats_list(page,additionals);
                    return false;
                });
                $('.'+module_name+'-stats-list:visible .sort_trigger').on('click',function(){
                    var new_sort_term = $(this).attr('rel');
                    if(new_sort_term == additionals.sort_term){
                        if(additionals.sort_way == 'DESC') additionals.sort_way = 'ASC';
                        else additionals.sort_way = 'DESC';
                    }else{
                        additionals.sort_term = new_sort_term;
                        additionals.sort_way = 'DESC';
                    }
                    module.load_stats_list(0,additionals);
                    return false;
                });

            }
        });
    },

	init:function(){
        var module_name = this.data.module,  module = this;
    }
});

$(document).ready(function(){
    "use strict";
    CrmAutoresponders.init();
});
